<template>
  <div class="animated fadeIn">

    <!-- Main area -->
    <b-card>

      <b-row class="mb-4">
        <b-col sm="3">
          <h4 id="teammate-details" class="card-title mb-0">Detailed Teammate View</h4>
          <div class="small text-muted">{{ periodStartDay }} - {{ currentDay }}</div>
        </b-col>
        <b-col sm="3">
          <v-select 
          label="real_name" 
          :options="teammates"
          :value="selectedTeammate"
          :searchable="true"
          :close-on-select="true"
          ref="teammateSelector"
          @input="teammateSelected">
            <template slot="option" slot-scope="option">
              <img :src="option.avatar" class="img-avatar" style="height: 40px;"/>
              {{ option.real_name }}
            </template>
          </v-select>
        </b-col>
        <b-col sm="1">
          <template v-if="detailDataLoaded && selectedTeammate !== null">
            <img class="img-avatar" :src="selectedTeammate.avatar" />
          </template>
        </b-col>

      </b-row>

      <template v-if="detailDataLoaded && selectedTeammate !== null">

        <b-row>
          <b-col sm="12">
          <b-tabs class="w-100 mt-2">
            <b-tab active>
              <template slot="title">
                <h5><i class="far fa-handshake mr-1"></i>Messaging & Social</h5>
              </template>

              <b-row >
                <b-col sm="3">
                  <b-card :no-body="true">
                    <b-card-body class="p-3 clearfix">
                      <b-table 
                      class="mb-0 table-sm" 
                      responsive="sm" 
                      hover 
                      sort-icon-left
                      small
                      head-variant="dark"
                      :items="topChannelTableData" 
                      :fields="topChannelFields"
                      :sort-by.sync="topChannelSortBy"
                      :sort-desc.sync="topChannelSortDesc">
                        <div slot="channel" slot-scope="item">
                          <div>
                            <router-link :to="'/details/channel?cid=' + item.item.slackId" class="unstyled-link">
                              {{item.value}}
                            </router-link>
                          </div>
                        </div>

                        <div slot="messages" slot-scope="item">
                          <div>{{ item.value }}</div>
                        </div>
                      </b-table>
                    </b-card-body>
                  </b-card>
                </b-col>

                <b-col sm="4">
                  <b-card :no-body="true">
                    <b-card-body class="p-3 clearfix">
                      <div class="text-muted text-uppercase font-weight-bold font-s">Teammates Who Mentioned {{ selectedTeammate.real_name }}</div>
                      <b-table 
                      class="mb-0 table-sm" 
                      responsive="sm" 
                      hover 
                      sort-icon-left
                      small
                      head-variant="dark"
                      :items="mentionersTableData" 
                      :fields="mentionersFields"
                      :sort-by.sync="mentionersSortBy"
                      :sort-desc.sync="mentionersSortDesc">
                        <div slot="avatar" class="avatar" slot-scope="item">
                          <img :src="item.value.url" class="img-avatar" alt="">
                        </div>

                        <div slot="teammate" slot-scope="item">
                          <div>
                            <router-link :to="'/details/teammate?uid=' + item.item.slackId" class="unstyled-link">
                              {{item.value}}
                            </router-link>
                          </div>
                        </div>

                        <div slot="mentions" slot-scope="item">
                          <div>{{ item.value }}</div>
                        </div>
                      </b-table>

                      <div class="text-muted text-uppercase font-weight-bold font-s">Teammates {{ selectedTeammate.real_name }} Mentioned</div>
                      <b-table 
                      class="mb-0 table-sm" 
                      responsive="sm" 
                      hover 
                      sort-icon-left
                      small
                      head-variant="dark"
                      :items="mentionedTableData" 
                      :fields="mentionersFields"
                      :sort-by.sync="mentionersSortBy"
                      :sort-desc.sync="mentionersSortDesc">
                        <div slot="avatar" class="avatar" slot-scope="item">
                          <img :src="item.value.url" class="img-avatar" alt="">
                        </div>

                        <div slot="teammate" slot-scope="item">
                          <div>
                            <router-link :to="'/details/teammate?uid=' + item.item.slackId" class="unstyled-link">
                              {{item.value}}
                            </router-link>
                          </div>
                        </div>

                        <div slot="mentions" slot-scope="item">
                          <div>{{ item.value }}</div>
                        </div>
                      </b-table>

                    </b-card-body>
                  </b-card>

                </b-col>

                <b-col sm="5">
                  <b-card :no-body="true">
                    <b-card-body class="p-3 clearfix">
                      <div class="text-muted text-uppercase font-weight-bold font-s">Social Channel Map</div>
                      <user-channel-social-radar-chart 
                      :chart-data="detailData.mentions"
                      :channel-data="teamChannels"
                      :user-id="selectedTeammate.id"
                      class="chart-wrapper" 
                      style="min-height: 400px; height:88%; margin-top:10px;"/>
                    </b-card-body>
                  </b-card>

                </b-col>
              </b-row>

            </b-tab>

            <b-tab>
              <template slot="title">
                <h5><i class="far fa-comment-dots mr-1"></i>Key Phrases By Channel</h5>
              </template>

              <b-row>
                <template v-if="Object.keys(topGramsByChannel).length > 0">
                  <template v-for="(grams, channel_id) in topGramsByChannel">

                    <b-col md="5">
                      <b-card>
                        <div slot="header" class="text-dark font-weight-bold">
                          <router-link :to="'/details/channel?cid=' + $store.getters.teamChannel(channel_id).slack_id" class="unstyled-link">
                            #{{ $store.getters.teamChannel(channel_id).name }}
                          </router-link>
                        </div>

                        <grams-table :grams="grams"></grams-table>

                      </b-card>
                    </b-col>

                  </template>
                </template>
                <template v-else>
                  <p class="ml-4">Sorry, we haven't seen enough message data in the selected time window to generate key phrases for this user</p>
                </template>
              </b-row>

            </b-tab>


            <b-tab>
              <template slot="title">
                <h5><i class="far fa-chart-bar mr-1"></i>Messaging Hourly Stats</h5>
              </template>
              <user-message-and-mentions-activity-chart 
              :chart-data="detailData"
              :user-data="teammates"
              :user-id="selectedTeammate.id"
              class="chart-wrapper" 
              style="height: 400px; margin-top:20px;"/>

            </b-tab>
          </b-tabs>
          </b-col>

        </b-row>
      
      </template>
      <template v-else-if="selectedTeammate !== null && !detailDataLoaded">
      <div class="sk-folding-cube align-middle">
        <div class="sk-cube1 sk-cube"></div>
        <div class="sk-cube2 sk-cube"></div>
        <div class="sk-cube4 sk-cube"></div>
        <div class="sk-cube3 sk-cube"></div>
      </div>
    </template>

      
    </b-card>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import UserChannelSocialRadarChart from './detail/UserChannelSocialRadarChart'
import UserMessageAndMentionsActivityChart from './detail/UserMessageAndMentionsActivityChart'
import GramsTable from './common/GramsTable.vue'

export default {
  name: 'TeammateDetailDashboard',
  components: {
    GramsTable,
    UserChannelSocialRadarChart,
    UserMessageAndMentionsActivityChart
  },
  data: function () {
    return {
      pageName: 'teammatedetail',
      currentDay: moment().format('MMMM Do'),

      periodSelected: 'Day',
      periodStartDay: moment().subtract(7, 'd').format('MMMM Do'),
      periodStartTimestamp: moment().subtract(7, 'd'),

      selectedTeammate: null,

      filterWakeupsEnabled: true,
      onlinePresenceChartDataReady: true, // handle vue-chartjs reactiveProp fussyness

      mentionersFields: {
        avatar: {
          label: '', //'<i class="icon-people"></i>',
          class: 'text-center'
        },
        teammate: {
          label: 'Teammate'
        },
        mentions: {
          key: 'mentions',
          sortable: true,
          label: '# Mentions'
        }
      },
      mentionersSortBy: 'mentions',
      mentionersSortDesc: true,

      topChannelFields: {
        channel: {
          label: 'Channel'
        },
        messages: {
          sortable: true,
          key: 'messages',
          label: '# Messages'
        },
      },
      topChannelSortBy: 'messages',
      topChannelSortDesc: true,

      userSessionFields: {
        start: {
          sortable: true,
          key: 'start',
          label: 'Signed On'
        },
        end: {
          key: 'end',
          label: 'Signed Off'
        },
        duration: {
          label: 'Duration'
        }
      },
      sessionSortBy: 'start',
      sessionSortDesc: true,
    
    }
    
  },

  watch: {
    timePeriod: function(period, lastPeriod) {
      if(this.$store.getters.currentPage === this.pageName) {
        this.fetchDetailData(period)
      }
    },

    uriUser: function(uriUser, lastUriUser) {
      if(uriUser) {
        this.$store.commit('teammateDetailDataLoaded', false)
        this.selectedTeammate = uriUser
      }
    },
  },

  computed: {
    timePeriod() {
      let p = this.$store.getters.timePeriod
      return p
    },
    teammates() {
      return this.$store.getters.teamMembers
    },
    teamChannels() {
      return this.$store.getters.teamChannels
    },

    detailData() {
      return this.$store.getters.teammateDetailData
    },
    detailDataLoaded() {
      return this.$store.getters.teammateDetailDataLoaded
    },

    uriUser() {
      if('uid' in this.$route.query) {
        let uid = this.$route.query.uid
        let user = this.$store.getters.teamMemberBySlackId(uid)
        if(typeof user == 'undefined') {
          return false
        }
        return user
      } else {
        return false
      }
    },

    topChannelTableData() {
      let formattedChannels = []
      for(const row of this.detailData.channels) {
        let channel = this.$store.getters.teamChannel(row.channel_id)
        formattedChannels.push({
          channel: '#' + channel.name,
          slackId: channel.slack_id,
          messages: row.total_messages
        })
      }
      return formattedChannels
    },
    mentionersTableData() {
      let mentionerCounts = {}
      let formattedMentioners = []
      for(const row of this.detailData.mentions) {
        if(row.at_id == this.selectedTeammate.id) {
          if(row.sender_id in mentionerCounts) {
            mentionerCounts[row.sender_id] += row.mentions
          } else {
            mentionerCounts[row.sender_id] = row.mentions
          }
        }
      }

      for(const uid of Object.keys(mentionerCounts)) {
        let user = this.$store.getters.teamMember(uid)
        formattedMentioners.push({
          avatar: {url: user.avatar, status: ''},
          teammate: user.real_name,
          slackId: user.slack_id,
          mentions: mentionerCounts[uid]
        })
      }
      return formattedMentioners
    },
    mentionedTableData() {
      let mentionedCounts = {}
      let formattedMentioned = []
      for(const row of this.detailData.mentions) {
        if(row.sender_id == this.selectedTeammate.id) {
          if(row.at_id in mentionedCounts) {
            mentionedCounts[row.at_id] += row.mentions
          } else {
            mentionedCounts[row.at_id] = row.mentions
          }
        }
      }

      for(const uid of Object.keys(mentionedCounts)) {
        let user = this.$store.getters.teamMember(uid)
        formattedMentioned.push({
          avatar: {url: user.avatar, status: ''},
          teammate: user.real_name,
          slackId: user.slack_id,
          mentions: mentionedCounts[uid]
        })
      }
      return formattedMentioned
    },

    topGramsByChannel() {
      return this.detailData.top_grams_by_channel
    }
  },
  
  methods: {
    teammateSelected(value) {
      this.selectedTeammate = value

      if(value !== null) {
        this.fetchDetailData(this.timePeriod)
      }
    },

    filterWakeupsClicked: function(event) {
      // this event comes before the data is actually changed.  flip to false to not upset vue-chartjs
      this.onlinePresenceChartDataReady = false
    },
    filterWakeupsChecked: function(state) {
      // console.log('PC Wakeups Filtering: ' + this.filterWakeupsEnabled)
      this.onlinePresenceChartDataReady = true
    },

    formattedSessionLength: function(start, end) {
      let duration = (end == null || end == 'None')
        ? moment().subtract(start, 's').valueOf() / 1000
        : end - start
      // console.log(duration)

      // duration currently in seconds
      if(duration >= 3600) {
        // convert to hours
        return (Math.round(duration / 60 / 60 * 10) / 10).toString() +  ' hours'
      } else if(duration >= 60) {
        // convert to minutes
        return (Math.round(duration / 60 * 10) / 10).toString() +  ' minutes'
      } else {
        // use seconds
        return duration.toString() + ' seconds'
      }
    },

    fetchDetailData: function(period) {
      // console.log(this.selectedTeammate)
      this.$store.dispatch('updateTeammateDetailData', [period, this.selectedTeammate.id])

      if(period == '6h') {
        this.periodStartTimestamp = moment().subtract(6, 'h')
      } else if(period == '12h') {
        this.periodStartTimestamp = moment().subtract(12, 'h')
      } else if(period == 'Day') {
        this.periodStartTimestamp = moment().subtract(1, 'd')
      } else if(period == 'Week') {
        this.periodStartTimestamp = moment().subtract(7, 'd')
      } else if(period == '2Weeks') {
        this.periodStartTimestamp = moment().subtract(14, 'd')
      } else if(period == 'Month') {
        this.periodStartTimestamp = moment().subtract(30, 'd')
      }

      this.periodStartDay = this.periodStartTimestamp.format('MMMM Do')
    }
  },

  mounted() {
    this.$store.commit('currentPage', this.pageName)
    this.$store.commit('teammateDetailDataLoaded', false)

    let userFromUri = this.uriUser
    // console.log(userFromUri)
    if(userFromUri) {
      // console.log(userFromUri)
      // this triggers the @input event on the vue-select object
      this.selectedTeammate = userFromUri
      // setTimeout(() => this.selectedTeammate = userFromUri, 1000)
    }
  },

  beforeDestroy() {
    this.$store.commit('teammateDetailDataLoaded', false)
  }
}
</script>
